<script>
  import { createEventDispatcher } from 'svelte';

  import Modal from './Modal.svelte';
  import Button from './Button.svelte';

  const dispatch = createEventDispatcher();
  const SLOTS = $$props.$$slots || {};

  export let show;
  export let question;
  export let objectText;
  export let yesButtonText;
  export let cancelText = 'Cancel';
  export let allowClose = true;
  export let mobile = false;
  export let yesButtonParams = {};
  export let closeOnOverlayClick = true;

  let hide;

  let yesActionClick = function () {
    yesButtonParams = { ...yesButtonParams, loading: true };
    dispatch('yes-click');
    hide();
  };

  let cancelClick = function () {
    dispatch('cancel');
    hide();
  };
</script>

<style style="text/scss" lang="scss">
  * :global(.alert-modal-container) {
    width: 490px !important;
    max-width: 490px !important;
  }

  .alert-container {
    text-align: center;

    .alert-question {
      font-weight: 500;
      font-size: 16px;
    }

    .alert-object-text {
      margin-top: 60px;
      font-size: 25px;
      line-height: 26px;
      font-weight: 500;
    }

    .alert-actions {
      margin-top: 65px;
      max-width: 275px;
      margin-left: auto;
      margin-right: auto;

      .alert-cancel-btn {
        color: #000;
        font-size: 15px;
        margin-top: 12px;
        font-weight: 500;
        border: none;
        background: transparent;
      }
    }
  }

  * :global(.alert-yes-btn:not(.use-default-style)) {
    height: 48px !important;
    color: #ff5567 !important;
    font-weight: 500 !important;
    font-size: 14px !important;
    border: none !important;
    border-radius: 15px !important;
    background: #fde7e7 !important;
    width: 275px !important;
    box-shadow: unset !important;

    &:hover {
      background: #ff5567 !important;
      color: white !important;
    }
  }
</style>

<div class="svelte-modal">
  <Modal
    on:close={() => {
      if (yesButtonParams) {
        yesButtonParams.loading = false;
      }

      dispatch('close');
    }}
    on:show={() => {
      dispatch('show');
    }}
    allowClose={allowClose}
    closeOnOverlayClick={closeOnOverlayClick}
    mobile={mobile}
    containerClass="alert-modal-container"
    bind:show={show}
    bind:hide={hide}
    class={$$props.class}
    showCloseButton={false}>
    <div slot="content" class="alert-container {$$props.class}">
      {#if SLOTS.content}
        <slot name="content" />
      {:else}
        {#if question}
          <div class="alert-question {$$props.questionClass}">
            {@html question}
          </div>
        {/if}
        {#if objectText}
          <div class="alert-object-text {$$props.objectClass}">
            {@html objectText}
          </div>
        {/if}
      {/if}
      <div class="alert-actions">
        {#if SLOTS.extra_action}
          <slot name="extra_action" />
        {/if}
        {#if SLOTS.action}
          <slot name="action" />
        {:else}
          {#if yesButtonText}
            <Button
              {...yesButtonParams}
              on:click={yesActionClick}
              text={yesButtonText}
              class="alert-yes-btn {$$props.yesButtonClass}" />
          {/if}

          {#if cancelText}
            <button
              on:click|preventDefault|stopPropagation={cancelClick}
              class="alert-cancel-btn {$$props.cancelButtonClass}">
              {cancelText}
            </button>
          {/if}
        {/if}
      </div>
    </div>
  </Modal>
</div>
